import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { useInvoiceStore } from "@components/modules/invoices/Create/store";
import { Card, NumberInput } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

export const BudgetItemsGlobalPercentInput = observer(
  function BudgetItemsGlobalPercentInput() {
    const invoiceStore = useInvoiceStore();
    const [percentValue, setPercentValue] = useState(0);

    if (!invoiceStore.canApplyGlobalPercent) return null;

    return (
      <Card px="5" py="3">
        <HStack align="center" spacing="4">
          <Text fontSize="sm" fontWeight="semibold" whiteSpace="nowrap">
            <Trans>Set selected to</Trans>
          </Text>
          <Box w="24">
            <NumberInput
              minValue={0}
              maxValue={100}
              suffix="%"
              decimalDigits={2}
              value={percentValue.toString()}
              onChange={(value) => setPercentValue(Number(value) || 0)}
            />
          </Box>
          <Button
            onClick={() => invoiceStore.applyGlobalPercent(percentValue)}
            variant="outline"
          >
            <Trans>Apply for selected</Trans>
          </Button>
        </HStack>
      </Card>
    );
  },
);
